import { Stopwatch } from './stopwatch';

export const DEFAULT_SETTINGS_KEY = 'default';
export const CONSOLE_TRANSPORT_NAME = 'console';
export const HTTP_TRANSPORT_NAME = 'http';

export interface LoggerOptions {
  transports: {
    [name: string]: LoggerTransportSettings;
  };
  settings: {
    [name: string]: LoggerSettings;
  };
}

export interface LoggerSettings {
  transports?: string[];
  logLevel: LogLevel;
}

export interface RegisteredTransports {
  [name: string]: any;
}

export interface LoggerTransportSettings {
  [name: string]: any;
}

export interface LoggerTransport {
  sendMessage(message: LogMessage);
}

export interface Logger {
  logMessage(level: LogLevel, message: string, data?: any, context?: any): void;
  logDebug(message: string, data?: any, context?: any): void;
  logTrace(message: string, data?: any, context?: any): void;
  logInfo(message: string, data?: any, context?: any): void;
  logWarning(message: string, data?: any, context?: any): void;
  logError(message: string, data?: any, context?: any): void;
  withContext(context: any): Logger;
  withMethod(method: string): Logger;
  startStopwatch(logLevel: LogLevel, message?: string, data?: any): Stopwatch;
}

export interface LogMessage {
  timestamp: string;
  message: string;
  level: LogLevel;
  context: any;
  data: any;
}

export enum LogLevel {
  Trace = 0,
  Debug = 1,
  Info = 2,
  Warning = 3,
  Error = 4
}
